import React from 'react';
import { ProductCardBase } from '../ProductCard';
import clsx from 'clsx';
import { Button, CardContent, CardHeader, Typography } from 'ui-kit';
import { LocalProduct } from 'api/types/localproduct';
import { formatCurrency } from 'utils';
import ProductCartLabel from '../ProductCartLabel';
import { isExternalLink, isPreorderProduct, isRequest as isRequestProduct } from 'utils/product';
import './LocalProductCard.scss';

type Props = {
  product: LocalProduct;
  className?: string;
  onClick?: () => void;
};

export default function LocalProductCard({ product, className, onClick }: Props) {
  const { currency, price, image, isNational } = product;

  const handleCardClick = () => {
    onClick();
  };
  const isLink = isExternalLink(product);
  const isPreorder = isPreorderProduct(product);
  const isRequest = isRequestProduct(product);
  return (
    <ProductCardBase
      className={clsx(className, 'LocalProductCard')}
      onClick={() => handleCardClick()}
      imgSrc={image}
    >
      <CardHeader
        title={product?.name}
        subheader={
          <Typography variant="body1" color="secondary" className="LocalProductCard_price">
            {!isLink && `${formatCurrency(price, currency)}`}
          </Typography>
        }
      />
      <CardContent>
        <Button variant="contained" color="textDark" fullWidth onClick={handleCardClick}>
          View
        </Button>
      </CardContent>
      <div className="LocalProductCard_labels">
        {isNational && <ProductCartLabel label="National" />}
        {isPreorder && !isRequest && <ProductCartLabel label="Pre-order" />}
        {isRequest && <ProductCartLabel label="Request" />}
        {isLink && <ProductCartLabel label="Link" />}
      </div>
    </ProductCardBase>
  );
}
